import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import ContractTemplateListScreen from "../screens/ContractTemplateListScreen";
import EditContractScreen from "../screens/EditContractScreen";
import EditContractTemplateScreen from "../screens/EditContractTemplateScreen";
import NewContractTemplateScreen from "../screens/NewContractTemplateScreen";

import useViewer from "../hooks/useViewer";

type ContractRouterProps = {} & RouteComponentProps;

const ContractRouter: React.FC<ContractRouterProps> = ({ match }) => {
  const viewer = useViewer();

  return (
    <Switch>
      <Route
        path={`${match.path}/:contractTemplateId/mads/:madId/edit`}
        exact
        component={EditContractScreen}
      />
      <Route
        path={`${match.path}/templates`}
        exact
        component={ContractTemplateListScreen}
      />
      <Route
        path={`${match.path}/templates/new`}
        exact
        component={NewContractTemplateScreen}
      />
      <Route
        path={`${match.path}/templates/edit/:id`}
        exact
        component={EditContractTemplateScreen}
      />
    </Switch>
  );
}

export default ContractRouter;
